export default "__VITE_ASSET__5cbecbf3__"